import cx from 'classnames'
import _ from '@/utils/lodash-optimized'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { MdExpandMore } from 'react-icons/md'

import { useClickOutside } from '../../../../../hooks'
import { capitalize } from '../../../utils'
import styles from '../select.module.scss'

import { SelectItem } from './select-item'

export function Edit ({
  relation,
  handler,
  disabled,
  selected,
  edit,
  currentAssignee,
  currentUser,
  lists,
  nullable = false,
  detail = false
}) {
  const [ isOpen, setOpen ] = useState(false)
  const [ letter, setLetter ] = useState(null)
  const wrapperRef = useRef(null)
  const scrollViewRef = useRef(null)
  useClickOutside(wrapperRef, () => {
    setOpen(false)
  })

  let disable = disabled

  if (relation.key === 'status') {
    disable = currentAssignee !== currentUser
  }

  const sortFn = useCallback((prev, next) => {
    const prevName = prev?.name?.toLowerCase()
    const nextName = next?.name?.toLowerCase()
    if (prevName && nextName) {
      const _letter = letter.toLowerCase()
      const prevNameIndex = prevName.indexOf(_letter)
      const nextNameIndex = nextName.indexOf(_letter)
      if (prevNameIndex === -1) {
        return 1
      }
      if (nextNameIndex === -1) {
        return -1
      }
      if (prevNameIndex > nextNameIndex) {
        return 1
      }
      if (prevNameIndex < nextNameIndex) {
        return -1
      }
    }
    return 0
  }, [ letter ])

  useEffect(() => {
    if (!letter) {
      return
    }

    const sortedData = _.cloneDeep(lists)?.[relation.key]?.sort(sortFn)
    if (!sortedData[0]?.name) {
      return
    }

    const el = document.getElementById(sortedData[0].name)
    if (!el) {
      return
    }

    scrollViewRef.current.scrollTo({
      top: el.offsetTop,
      left: 0,
      behavior: 'smooth'
    })
  }, [ letter, lists, relation.key, sortFn ])

  if (relation.type === 'input') {
    return (
      <input
        value={selected.id}
        type='text'
        className={cx(styles.input, styles.comment)}
        placeholder={relation.label}
        disabled={disable}
        onChange={e => handler(relation.key, e.target.value)}
      />
    )
  }

  return (
    <button
      className={cx(styles.itemsWrapper, {
        [styles.editable]: edit
      })}
      ref={wrapperRef}
      tabIndex={0}
      onKeyDown={e => setLetter(e.key)}
    >
      <div
        className={styles.typeSelect}
        id='select'
        onClick={() => !disable && setOpen(s => !s)}
        aria-hidden='true'
      >
        <span
          className={cx(styles.label, {
            [styles.unavailable]: selected?.id && selected?.key && lists[selected.key]?.find(l => l.id === selected?.id)?.unavailable
          })}
        >
          {selected?.id && selected?.key
            ? lists[selected.key]?.find(l => l.id === selected?.id)?.name
            : relation.label}
        </span>
        <div style={{ width: '16px', height: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <MdExpandMore height={16} />
        </div>
      </div>
      {lists[relation.key].length > 0 && (
        <div
          className={cx(styles.items, {
            [styles[relation.key]]: isOpen,
            [styles.hide]: !isOpen
          })}
          ref={scrollViewRef}
        >
          {nullable && (
            <div
              className={styles.selectItem}
              id={relation.label}
              onClick={() => {
                handler(relation.key, null, detail)
              }}
              aria-hidden='true'
            >
              {capitalize(relation.label)}
            </div>
          )}

          {lists[relation.key].map((element, k) => (
            <SelectItem
              key={`${element.id}-${k}`}
              item={element}
              disabled={disable}
              rel={relation.values}
              detail={detail}
              editMode
              handleChecked={() => {
                if (!disable) {
                  handler(relation.key, element.id, detail)
                }
                setOpen(false)
              }}
            />
          ))}
        </div>
      )}
    </button>
  )
}
